import { getResource, getResourceUserService } from "@/services/resource";
import {
  SET_RAM,
  SET_CPU,
  SET_STORAGE,
  SET_RESOURCE,
  SET_RESOURCE_SERVICE,
  SET_DEFAULT_RESOURCE
} from "../mutation-types";

export default {
  [SET_DEFAULT_RESOURCE]: status => {
    status.cpu.value = 1;
    status.ram.value = 1;
    status.storage.value = 1;
  },
  [SET_RESOURCE]: async state => {
    state.loading = true;
    const [error, data] = await getResource();
    if (error) {
      state.loading = false;
      state.showError = true;
      state.errorMessages = error;
    } else {
      if (data.apiStatus === 200) {
        state.errorMessages = [];
        state.cpu = { ...state.cpu, ...data.apiData.cpu };
        state.ram = { ...state.ram, ...data.apiData.ram };
        state.storage = { ...state.storage, ...data.apiData.storage };
        state.loading = false;
      } else {
        state.loading = false;
        state.showError = true;
        state.errorMessages = data.apiErrors;
      }
    }
  },
  [SET_RESOURCE_SERVICE]: async (state, serviceId) => {
    state.loading = true;
    const [error, data] = await getResourceUserService(serviceId);
    if (error) {
      state.errorMessages = error;
      state.loading = false;
    } else {
      if (data.apiStatus === 200) {
        state.cpu = { ...state.cpu, value: data.apiData.cpu };
        state.ram = { ...state.ram, value: data.apiData.ram };
        state.storage = { ...state.storage, value: data.apiData.storage };
        state.errorMessages = [];
        state.loading = false;
      } else {
        state.errorMessages = data.apiErrors;
        state.loading = false;
      }
    }
  },
  [SET_RAM]: (state, val) => {
    state.ram.value = val;
  },
  [SET_CPU]: (state, val) => {
    state.cpu.value = val;
  },
  [SET_STORAGE]: (state, val) => {
    state.storage.value = val;
  }
};
